import { Box, MenuItem, TextField } from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

// Supply options
const SUPPLY_OPTIONS = [
  { value: 30, label: "30 days, 30 capsules" },
  { value: 60, label: "60 days, 60 capsules" },
  { value: 90, label: "90 days, 90 capsules" },
];

interface FormulaInformationProps {
  supply: number | undefined;
  onChangeSupply: (value: number) => void;
  error?: boolean;
}

function FormulaInformation({
  supply,
  onChangeSupply,
  error = false,
}: FormulaInformationProps) {
  const { colors } = useCelleraTheme();

  const showError = error && supply === undefined;

  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Box sx={{ flex: 1, maxWidth: "20%" }}>
        <TextField
          fullWidth
          select
          required
          label="Supply"
          value={supply}
          onChange={(e) => onChangeSupply(Number(e.target.value))}
          size="medium"
          placeholder="Select Supply"
          error={showError}
          helperText={showError ? "Supply is required" : ""}
          sx={{
            "& .MuiOutlinedInput-root": {
              backgroundColor: colors.background.paper,
            },
          }}
        >
          {SUPPLY_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
}

export default FormulaInformation;
